module.exports = __webpack_public_path__ + "static/media/Safe-T30.b10bae47.jpg";